// components/banner.js
'use client';

import { Skeleton, Flex, Input, Carousel } from 'antd'
import { CameraOutlined, HomeOutlined } from "@ant-design/icons";
import Image from 'next/image'
import { useState } from 'react';
// import { useRouter } from 'next/navigation';
import { useRouter } from 'nextjs-toploader/app';
import SearchUpload from "@/components/AliUpload/search_upload";
import { encryptData } from "@/lib/utils";

export default function Banner({ banner }) {

    const router = useRouter();

    const [searchKey, setSearchKey] = useState('');

    const [bannerIndex, setBannerIndex] = useState(0);

    const showDots = banner.length > 1;

    const handleClickBanner = (item) => {
        if (item.url != '/') {
            window.open(item.url, '_blank')
        }
    }

    const handleSearch = () => {
        router.push(`/search?type=products&searchKey=${searchKey}`)
    }

    const afterChange = (current) => {
        setBannerIndex(current)
    }

    const handleUploadDone = url => {
        router.push(`/search?type=identifying&searchKey=${encryptData(url)}`)
    }

    return (

        <div className='banner_bx'>
            <Carousel className='banner_carousel' dots={showDots} autoplay fade waitForAnimate afterChange={afterChange}>
                {
                    banner.map((item, index) => (
                        <div className='banner_view' key={index}>
                            {/* <div className='banner_view_bg' style={{ backgroundImage: `url(${item})` }}></div> */}
                            <Image src={item.pic} fill alt='banner' priority onClick={() => handleClickBanner(item)} objectFit='cover' />
                        </div>
                    ))
                }
                {/* <div className='banner_view'>
                    <Image src={banner} fill alt='banner' priority quality={75} onClick={() => handleClickBanner()} />
                </div> */}
            </Carousel>
            <div className='box_warp'>
                <div className='banner_title'>
                    {banner?.[bannerIndex]?.title !== '/' && banner?.[bannerIndex]?.title}
                </div>
                <div className='banner_desc'>
                    {banner?.[bannerIndex]?.desc !== '/' && banner?.[bannerIndex]?.desc}
                </div>

                <Flex align="center" className="banner_search_input" id='bannerSearch'>
                    <Input type="text" placeholder="Search for products" className="search_input" onChange={(e) => setSearchKey(e.target.value)} onPressEnter={handleSearch} />
                    {/* <CameraOutlined className="search_icon icon_flex" /> */}
                    <SearchUpload handleUploadDone={handleUploadDone} />
                    <Flex align="center" justify="center" className="search_btn" onClick={handleSearch}>Search</Flex>
                </Flex>
            </div>
        </div>

    );
}